module.exports = __webpack_public_path__ + "img/logo-jeco.8a6e33c5.svg";